(function () {
	document.addEventListener("DOMContentLoaded", () => {
		// TODO: JavaScript code here.
	});
})();
